import logo from "./bLogo.png";
import "./App.css";

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="" alt="logo" width={400} />

        <a
          className="App-link"
          href="https://www.bytnsa.com/"
          target="_blank"
          rel="noopener noreferrer"
        >
          www.bytnsa.com
        </a>
      </header>
    </div>
  );
}

export default App;
